import * as React from 'react';
import { FC } from 'react';

import { Icon, Text } from '@rbilabs/universal-components';
import { spacing } from '@rbilabs/universal-components/themes';
import { useStore } from 'features/store/hooks/use-store';
import { useIntl } from 'react-intl';
import { Linking, StyleSheet, View } from 'react-native';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { primitive } from 'styles/constants/primitives';

const NYCRegulatoryLink: FC<React.PropsWithChildren> = () => {
  const { formatMessage } = useIntl();
  const { store } = useStore();
  const nycRegulatoryLinkAddress = useFlag(LaunchDarklyFlag.NYC_REGULATORY_LINK);

  const handleLinkPress = () => {
    Linking.openURL(nycRegulatoryLinkAddress ?? '');
  };

  if (!store?.physicalAddress || !nycRegulatoryLinkAddress) {
    return null;
  }

  return (
    <View style={styles.badgeContainer}>
      <Icon
        accessibilityHidden
        title="Store"
        variant="store"
        size="xs"
        color={primitive.$blackOpacity50}
      />
      <StyledText>
        <StyledText fontWeight="bold" textTransform="capitalize">{`${formatMessage({
          id: 'restaurant',
        })}: `}</StyledText>
        {store.physicalAddress.address1}
        {' - '}
        <StyledLink underline onPress={handleLinkPress}>
          {formatMessage({ id: 'nycRestaurantHealthRatings' })}
        </StyledLink>
      </StyledText>
    </View>
  );
};

const styles = StyleSheet.create({
  badgeContainer: {
    alignSelf: 'flex-start',
    flexDirection: 'row',
    borderRadius: 5,
    paddingTop: spacing.$1,
    paddingBottom: spacing.$1,
    paddingLeft: spacing.$2,
    paddingRight: spacing.$2,
    marginBottom: spacing.$6,
    backgroundColor: primitive.$blackOpacity4,
  },
});

const StyledText = Text.withConfig({
  variant: 'bodyOne',
  fontSize: '2xs',
  marginLeft: '$1',
  color: primitive.$blackOpacity50,
});

const StyledLink = StyledText.withConfig({
  marginLeft: 0,
});

export default NYCRegulatoryLink;
